export default __webpack_public_path__ + "images/YZ.27b6cba.png";